var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacy = function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 12.3002C8.2 12.4002 8.4 12.6002 8.6 12.6002C8.8 12.7002 9 12.7002 9.2 12.7002C9.4 12.7002 9.6 12.7002 9.8 12.6002C10 12.5002 10.2 12.4002 10.3 12.3002L13.3 9.3002C13.6 9.0002 13.8 8.6002 13.8 8.2002C13.8 7.8002 13.6 7.4002 13.3 7.1002L9.7 3.5002C9.6 3.3002 9.4 3.2002 9.2 3.2002H5C4.6 3.2002 4.2 3.6002 4.2 4.0002V8.2002C4.2 8.4002 4.3 8.6002 4.4 8.7002L8.1 12.3002ZM5.8 4.8002H8.9L12.3 8.2002V8.3002L9.3 11.3002L9.8 11.8002L9.1 11.3002L5.8 7.9002V4.8002ZM4 20.0002H13V18.5002H4V20.0002ZM4 14.5002V16.0002H20V14.5002H4Z",
    fill: "#444444"
  })));
};
export { SvgPrivacy as ReactComponent };